import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResourceEmployeeProfile, ResourceUserOption } from '../../../../Models/resource-modules.models';

export interface ResourcePlanningMembersDialogData {
  /** Bestehende Benutzerkonten, die noch nicht manuell aufgenommen sind. */
  candidates: ResourceUserOption[];
  /** Profile zur Anzeige, ob jemand bereits über ein Team in der Gesamtplanung ist. */
  profiles: ResourceEmployeeProfile[];
}

/**
 * „Zur Gesamtplanung hinzufügen“: durchsuchbare Mehrfachauswahl bestehender
 * Benutzerkonten (gleiche Auswahl wie beim Hinzufügen von Teammitgliedern). Es werden
 * keine Konten angelegt. Liefert die gewählten Benutzer-IDs.
 */
@Component({
  selector: 'app-resource-planning-members-dialog',
  templateUrl: './resource-planning-members-dialog.component.html',
  styleUrls: ['../resource-team-management.shared.css', './resource-planning-members-dialog.component.css']
})
export class ResourcePlanningMembersDialogComponent {
  selectedIds: string[] = [];
  search = '';

  private readonly profileById: Map<string, ResourceEmployeeProfile>;

  constructor(
    private dialogRef: MatDialogRef<ResourcePlanningMembersDialogComponent, string[]>,
    @Inject(MAT_DIALOG_DATA) public data: ResourcePlanningMembersDialogData
  ) {
    this.profileById = new Map(data.profiles.map(p => [p.userId, p]));
  }

  get options(): ResourceUserOption[] {
    const q = this.search.trim().toLocaleLowerCase('de');
    return this.data.candidates.filter(u =>
      this.selectedIds.includes(u.userId) || !q ||
      u.name.toLocaleLowerCase('de').includes(q) ||
      (u.email ?? '').toLocaleLowerCase('de').includes(q));
  }

  get selected(): ResourceUserOption[] {
    return this.data.candidates.filter(u => this.selectedIds.includes(u.userId));
  }

  /** Bereits automatisch über ein Team in der Gesamtplanung. */
  isPlannedByTeam(userId: string): boolean {
    return !!this.profileById.get(userId)?.isPlannedByTeam;
  }

  remove(userId: string): void {
    this.selectedIds = this.selectedIds.filter(id => id !== userId);
  }

  confirm(): void {
    if (!this.selectedIds.length) return;
    this.dialogRef.close([...this.selectedIds]);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
